import { fetchWrapper } from "../utils/fetch-wrapper";

const bâtimentsService = {
  getAll,
  getById,
  post,
  update,
  delete: _delete,
  count,
};

function getAll(env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  return fetchWrapper.get(`bâtiments/?${queryString}`);
}

function getById(id) {
  return fetchWrapper.get(`bâtiments/${id}`);
}

function post(data) {
  return fetchWrapper.post("bâtiments/", data);
}

function update(id, params) {
  return fetchWrapper.put(`bâtiments/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`bâtiments/${id}`);
}

function count() {
  return fetchWrapper.get(`bâtiments/count`);
}

export default bâtimentsService;
